<template>
    <activation-proposals-view :proposals="proposals" />
</template>

<script>
import ActivationProposalMixin from "./mixins/ActivationProposalsMixin";
import ActivationProposalsView from "../data-views/activation-briefs/ActivationProposalsView.vue";
import { ACTIVATION_BRIEF_STATUS_DECLINED } from "../../constants/activation-brief";

export default {
        name:   'ActivationProposalsProvider',
        components: {ActivationProposalsView},
        mixins: [
            ActivationProposalMixin
        ],
        created() {
            const activationId = this.$route.params.activation_id;
            this.proposals = this.$root.briefs.filter((brief) => (brief.activation.id === activationId && brief.status !== ACTIVATION_BRIEF_STATUS_DECLINED));
        },
    };
</script>
